import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/cost_centers', { params });
  },
  create(data) {
    return axios.post('/v1/cost_centers', data);
  },
  detail(id) {
    return axios.get(`/v1/cost_centers/${id}`);
  },
  update(id, params) {
    return axios.put(`/v1/cost_centers/${id}`, params);
  },
  delete(id) {
    return axios.delete(`/v1/cost_centers/${id}`);
  }
};
